/**
 * Coerce a volume into the [0, 1] range Web Audio and HTMLMediaElement accept.
 * Both throw on non-finite input (Safari surfaces it as
 * "TypeError: The provided value is non-finite"), and HTMLMediaElement.volume
 * additionally throws on out-of-range values — so every volume must pass
 * through here before it reaches an audio API or the sound store.
 */
export function toSafeVolume(value: number, fallback: number): number {
  if (!Number.isFinite(value)) return fallback
  return Math.min(Math.max(value, 0), 1)
}
